<template>
  <div class="widthFull mainBackground h-100 back-1">
    <loading v-if="loadingState" />
    <div class="container dataContainer">
      <form class="pb-5" id="editUser" @submit.prevent="editUser">
        <div class="row justify-content-center mt-5 pb-5">
          <div class="col-12">
            <h1 class="h1 darkBlue center mb-5 pt-5 mt-5 uppercase Bold">
              <b>Il tuo profilo</b>
            </h1>
          </div>
          <div class="col-md-6">
            <div class="group" :key="0">
              <input
                type="text"
                class="form-control dis"
                v-model="company"
                disabled
                id="company"
                name="company"
                data-vv-as="Ragione sociale"
                v-validate="{ required: true, max: 128, min: 2 }"
                :class="{
                  'is-invalid': errors.has('company'),
                  valid: !!company,
                }"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="company"
                >Ragione sociale
              </label>
              <div v-if="errors.has('company')" class="invalid-feedback">
                {{ errors.first("company") }}
              </div>
            </div>
            <div class="group" :key="1">
              <input
                type="text"
                class="dis form-control"
                disabled
                v-model="piva"
                id="piva"
                name="piva"
                data-vv-as="Partita IVA"
                v-validate="{ required: true, max: 11, min: 11 }"
                :class="{ 'is-invalid': errors.has('piva'), valid: !!piva }"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="piva">Partita IVA </label>
              <div v-if="errors.has('piva')" class="invalid-feedback">
                {{ errors.first("piva") }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="group" :key="2">
              <input
                type="text"
                class="form-control dis"
                disabled
                v-model="cod"
                id="cod"
                name="cod"
                data-vv-as="Codice Utente"
                v-validate="{ required: true, max: 11, min: 5 }"
                :class="{ 'is-invalid': errors.has('cod'), valid: !!cod }"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="piva">Codice utente </label>
              <div v-if="errors.has('cod')" class="invalid-feedback">
                {{ errors.first("cod") }}
              </div>
            </div>
            <div class="group" :key="3">
              <input
                type="text"
                v-model="email"
                disabled
                class="form-control dis"
                id="email"
                name="email"
                ref="email"
                data-vv-as="Email"
                v-validate="{
                  required: true,
                  email: true,
                  temporaryEmail: true,
                  plusIssueEmail: true,
                  max: 56,
                }"
                :class="{
                  'is-invalid': errors.has('email') || existEmail,
                  valid: !!email,
                }"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="email">Email </label>
              <div
                v-if="existEmail"
                class="invalid-feedback"
                style="display: block"
              >
                <span v-if="existEmailSocial"
                  >Email digitato già presente. Sei registrato con:
                  <strong class="text-capitalize">{{
                    existEmailSocial
                  }}</strong></span
                >
                <span v-else>Email digitato già presente</span>
              </div>
              <div v-if="errors.has('email')" class="invalid-feedback">
                {{ errors.first("email") }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="group">
              <select
                v-model="province"
                autocomplete="randomy"
                id="province"
                name="province"
                @change="provOk($event)"
                class="form-control"
                data-vv-as="Provincia"
                v-validate="{}"
                :class="{
                  'is-invalid': errors.has('province'),
                  valid: !!province,
                }"
              >
                <option
                  v-if="!shipData.province"
                  disabled
                  value=""
                  selected="selected"
                ></option>
                <option v-else :value="shipData.province" selected="selected">
                  {{ shipData.province }}
                </option>
                <option
                  v-for="province in provincies"
                  :key="province.sigla"
                  v-bind:value="province.sigla"
                  :selected="province.sigla == shipData.province"
                >
                  {{ province.sigla }} - {{ province.provincia }}
                </option>
              </select>
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="province">Provincia </label>
              <div v-if="provinciesState">
                <font-awesome-icon
                  class="loadSpinner"
                  id="loadProvince"
                  icon="spinner"
                  size="1x"
                  pulse
                />
              </div>
              <div v-if="errors.has('province')" class="invalid-feedback">
                {{ errors.first("province") }}
              </div>
            </div>
            <div class="group">
              <div v-if="!zip && !city" class="fix-2">{{ myzip }}</div>
              <select
                class="form-control"
                autocomplete="randomi"
                v-model="zip"
                v-on:click="checkZip"
                id="zip"
                name="zip"
                data-vv-as="Cap"
                v-validate="{}"
                :disabled="zipsState"
                :class="{
                  'is-invalid': errors.has('zip'),
                  valid: !!zip,
                }"
              >
                <option
                  v-if="!shipData.zip"
                  value=""
                  disabled
                  :selected="true"
                ></option>
                <option
                  v-for="zip in zips"
                  :key="zip.cap"
                  v-bind:value="zip.cap"
                  :selected="zip.cap == shipData.zip"
                >
                  {{ zip.cap }}
                </option>
              </select>
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="zip"
                >Codice postale
                <span v-if="zipError" class="formError"
                  >Prima scegli il comune</span
                >
              </label>
              <div v-if="zipsState">
                <font-awesome-icon
                  class="loadSpinner"
                  id="loadZips"
                  icon="spinner"
                  size="1x"
                  pulse
                />
              </div>
              <div v-if="errors.has('zip')" class="invalid-feedback">
                {{ errors.first("zip") }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="group">
              <div v-if="!city" class="fix-2">{{ mycity }}</div>
              <!--v-validate="{ required: isRequired }"-->
              <select
                class="form-control"
                autocomplete="randomu"
                v-model="city"
                v-on:click="checkProvince"
                id="city"
                name="city"
                data-vv-as="Comune"
                v-validate="{}"
                :disabled="citiesState"
                :class="{
                  'is-invalid': errors.has('city'),
                  valid: !!city,
                }"
              >
                <option
                  v-if="!shipData.city"
                  disabled
                  value="mycity"
                  selected="selected"
                ></option>
                <option
                  else
                  :value="{ city: shipData.city }"
                  selected="selected"
                >
                  {{ shipData.city }}
                </option>
                <option
                  v-for="city in cities"
                  :key="city.comune"
                  v-bind:value="{
                    cityistat: city.istat,
                    city: city.comune,
                  }"
                  :selected="city.comune == shipData.city"
                >
                  {{ city.comune }}
                </option>
              </select>

              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="city"
                >Comune
                <span v-if="cityError" class="formError"
                  >Prima scegli la provincia</span
                ></label
              >
              <div v-if="citiesState">
                <font-awesome-icon
                  class="loadSpinner"
                  id="loadCity"
                  icon="spinner"
                  size="1x"
                  pulse
                />
              </div>
              <div v-if="errors.has('city')" class="invalid-feedback">
                {{ errors.first("city") }}
              </div>
            </div>

            <div class="group" :key="4">
              <input
                type="text"
                class="form-control"
                v-model="address"
                id="address"
                name="address"
                data-vv-as="Indirizzo"
                v-validate="{ min: 5 }"
                :class="{
                  'is-invalid': errors.has('address'),
                  valid: !!address,
                }"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="address">Indirizzo</label>
              <div v-if="errors.has('address')" class="invalid-feedback">
                {{ errors.first("address") }}
              </div>
            </div>
          </div>
          <!--<div class="col-md-6">
            <div v-if="!group" class="group" :key="5">
              <input
                type="text"
                class="form-control"
                v-model="iban"
                id="iban"
                name="iban"
                data-vv-as="Iban"
                v-validate="{
                  
                  ibanItalian: true,
                  ibanControl: true,
                  min: 11,
                }"
                :class="{ 'is-invalid': errors.has('iban'), valid: !!iban }"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="piva">Iban</label>
              <div v-if="errors.has('iban')" class="invalid-feedback">
                {{ errors.first("iban") }}
              </div>
            </div>
            <div v-else class="group" :key="5">
              <input
                type="text"
                class="form-control"
                v-model="iban"
                id="iban"
                name="iban"
                data-vv-as="Iban"
                v-validate="{
                  
                  ibanItalian: true,
                  ibanControl: true,
                  min: 11,
                }"
                :class="{ 'is-invalid': errors.has('iban'), valid: !!iban }"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="piva">Iban</label>
              <div v-if="errors.has('iban')" class="invalid-feedback">
                {{ errors.first("iban") }}
              </div>
            </div>
            
            <div class="group" :key="7">
              <input
                type="text"
                class="form-control"
                v-model="accHolder"
                id="accHolder"
                name="accHolder"
                data-vv-as="Intestatario iban"
                v-validate="{ 
                   max: 55, min: 2 }"
                :class="{
                  'is-invalid': errors.has('accHolder'),
                  valid: !!accHolder,
                }"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="accHolder"
                >Intestatario iban</label
              >
              <div v-if="errors.has('accHolder')" class="invalid-feedback">
                {{ errors.first("accHolder") }}
              </div>
            </div>
            </div>-->
          <div class="col-md-6">
            <div class="group" :key="10">
              <input
                type="password"
                v-model="password"
                autocomplete="on"
                class="form-control"
                id="password"
                name="password"
                v-validate="{ passwordCheck: true, min: 8, max: 56 }"
                :class="{
                  'is-invalid': errors.has('password'),
                  valid: !!password,
                }"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel label" for="password"
                >Nuova Password</label
              >
              <div v-if="errors.has('password')" class="invalid-feedback">
                {{ errors.first("password") }}
              </div>
            </div>
            <div class="group" :key="11">
              <input
                type="password"
                v-model="confirm_password"
                autocomplete="on"
                class="form-control"
                id="confirm_password"
                name="confirm_password"
                data-vv-as="conferma password"
                v-validate="{
                  required: !!password,
                  confirmed: password,
                  passwordCheck: true,
                  min: 8,
                  max: 56,
                }"
                :class="{
                  'is-invalid': errors.has('confirm_password'),
                  valid: !!confirm_password,
                }"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel label" for="password"
                >Conferma Nuova Password</label
              >
              <div
                v-if="errors.has('confirm_password')"
                class="invalid-feedback"
              >
                {{ errors.first("confirm_password") }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div v-if="phone" class="group" :key="8">
              <input
                type="text"
                class="form-control dis"
                v-model="phone"
                placeholder="Inserisci il tuo numero di telefono nella pagina di caricamento"
                disabled
                id="phone"
                name="phone"
                data-vv-as="Telefono"
                v-validate="{
                  max: 11,
                  min: 8,
                  notZeros: true,
                  regex: /^[3]+/,
                }"
                :class="{ 'is-invalid': errors.has('phone'), valid: !!phone,'dis':phone }"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="phone">Telefono </label>
              <div v-if="errors.has('phone')" class="invalid-feedback">
                {{ errors.first("phone") }}
              </div>
            </div>
          </div>
          <div class="col-md-6"></div>
          <div class="col-md-10 mb-5 mb-md-0">
            <div class="form-group back-white" style="border-radius: 10px">
              <div class="form-check pl-0">
                <div class="group">
                  <!--<label class="form-check-label widthFull Medium" for="privacy">
                    Dichiaro di aver letto e compreso la normativa sulla
                    pricvacy cosí come le normative che regolamentano il
                    corretto utilizzo della piattaforma
                  </label>-->
                  <div
                    class="form-check form-check-inline mt-2"
                    v-if="privacy == 1"
                  >
                    <label class="Bold black">
                      Informativa accettata
                      <svg width="24" height="24" fill="#173f53">
                        <path
                          fill-rule="evenodd"
                          d="M17.818 5.693a.35.35 0 0 1 .27-.11.47.47 0 0 1 .305.11l.946 1.057c.09.073.135.17.135.292a.47.47 0 0 1-.135.328L9.203 18.307a.35.35 0 0 1-.27.11.47.47 0 0 1-.304-.11l-4.494-4.885A.356.356 0 0 1 4 13.13a.47.47 0 0 1 .135-.328l.946-1.02a.407.407 0 0 1 .304-.147c.113 0 .203.049.27.146l3.278 3.537 8.885-9.625z"
                        ></path>
                      </svg>
                    </label>
                  </div>

                  <br />
                  <span class="errorMes" v-show="errors.has('privacy')">
                    Il consenso deve essere accettato oppure rifiutato
                  </span>
                </div>
              </div>
              <div class="form-check pl-0">
                <div class="group">
                  <label class="form-check-label mb-3 Medium">
                    Puoi consultare la normativa sulla privacy cliccando qui:
                    <a
                      href="https://www.lierac.it/privacy-cookie-policy.html"
                      target="_blank"
                    >
                      Privacy Policy </a
                    >.
                  </label>
                </div>
              </div>
            </div>
            <div class="center mt-5 mt-md-3 mb-md-0 mb-5 pb-5">
              <button class="btn btn-primary mr-md-5" tag="button">
                CONFERMA MODIFICHE
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import axios from "axios";
import { USER_REQUEST } from "actions/user";

export default {
  name: "account",
  components: {},
  data() {
    return {
      email: "",
      name: "",
      accHolder: "",
      address: "",
      phone: "",
      password: "",
      confirm_password: "",
      privacy: "",
      cod: "",
      isRequired: false,
      iban: "",
      role: [],
      zipsState: false,
      cityError: false,
      zipError: false,
      tempMail: "",
      existEmail: false,
      existEmailSocial: false,
      addressData: false,
      loadingState: false,
      editStatus: false,
      group: false,
      userToken: "",
      company: "",
      myzip: "",
      provincies: [],
      provinciesState: true,
      cities: [],
      citiesState: false,
      mycity: "",
      zips: [],
      zipsState: false,
      zipError: false,
      province: "",
      shipData: {},
      city: "",
      piva: "",
      zip: "",
    };
  },
  methods: {
    checkProvince: function () {
      const { province } = this;
      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function () {
      const { city } = this;
      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    populateProvincies: function () {
      const { provincies, provinciesState } = this;
      axios({
        url: process.env.ROOT_API + "api/getProvincies",
        method: "POST",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.provincies = resp.data.provincies;
          this.provinciesState = false;
          this.province = this.profile.province;
        })
        .catch((resp) => {
          this.provincies = [];
          this.provinciesState = false;
        });
    },
    provOk: function (event) {
      this.mycity = "";
      this.myzip = "";
      this.isRequired = true;
    },
    editUser: function (e) {
      this.$validator.validate().then((valid) => {
        if (valid && this.userToken) {
          this.loadingState = true;
          if (!this.city) {
            this.city = this.mycity;
          }
          if (!this.zip) {
            this.zip = this.myzip;
          }
          var data = {
            phone: this.phone ? this.phone : "",
            accHolder: this.accHolder,
            iban: this.iban,
            email: this.email,
            userToken: this.userToken,
            company: this.company,
            password: this.confirm_password,
            token: this.confirm_password,
            address: this.address,
            zip: this.zip,
            location: this.city.city,
            province: this.province,
            id_platform: process.env.ID_PLATFORM,
            unique_key_db: process.env.UNIQUE_KEY_DB,
            vector_unique_key_db: process.env.ICODE,
            table: "utenti",
          };
          data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
          axios({
            url: process.env.ROOT_API + "api/editUser",
            data: {
              data,
            },
            method: "POST",
            headers: {
              Authorization: "Bearer " + process.env.AUTH_TOKEN,
              "Content-type": "application/json",
            },
          })
            .then((resp) => {
              this.loadingState = false;
              resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
              this.$track("editUser", "SUECCESS");
              if (resp.data) {
                if (resp.data == "not_modify") {
                  this.showAlertInfo("Non hai modificato alcun dato");
                } else {
                  this.$store
                    .dispatch(USER_REQUEST, this.userToken)
                    .then(() => {});
                  this.showAlertSuccess(
                    "I tuoi dati sono stati correttamente aggiornati"
                  );
                }
              } else {
                this.showAlertError(err.response.data.message);
              }
            })
            .catch((err) => {
              this.loadingState = false;
              err.response.data = this.$decryptByAES(
                err.response.data,
                process.env.CRYPTKEY
              );
              this.$track("editUser", "ERROR");
              this.showAlertError(err.response.data.message);
            });
        }
      });
    },
    showAlertError(value) {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: value + " !",
        onClose: () => {},
      });
    },
    showAlertSuccess(value) {
      // Use sweetalret2
      this.$swal({
        type: "success",
        title: value,
        showCancelButton: false,
        animation: false,
        onClose: () => {
          this.$router.push("/");
        },
      });
    },
    showAlertInfo(value) {
      // Use sweetalret2
      this.$swal({
        type: "info",
        title: value,
        showCancelButton: false,
        animation: false,
        onClose: () => {
          this.$router.push("/");
        },
      });
    },

    setProfileData: function () {
      if (this.profile.groupPh) {
        this.group = true;
      }
      this.email = this.profile.email;
      this.zip = this.profile.zip;
      this.accHolder = this.profile.accHolder;
      this.userToken = this.profile.userToken;
      this.piva = this.profile.piva;
      this.company = this.profile.company;
      this.phone = this.profile.phone;
      this.role = this.profile.role;
      this.iban = this.profile.iban;
      this.cod = this.profile.cod;
      this.address = this.profile.address;
      this.privacy = this.profile.consent;
      this.province = this.profile.province;
      this.mycity = this.profile.location;
      this.myzip = this.profile.zip;
    },
  },
  watch: {
    getProfile: function (val) {
      this.setProfileData();
    },
    phone: function (val) {
      if (val) {
        this.phone = val.replace(/\D+/g, "");
      }
    },
    province: function (newProvince) {
      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios({
          url: process.env.ROOT_API + "api/getComuni",
          method: "POST",
          data: {
            sigla: newProvince,
          },
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            this.cities = resp.data.cities;

            this.citiesState = false;
          })
          .catch((resp) => {
            this.cities = [];
            this.citiesState = false;
          });
      }
    },
    city: function (newCity) {
      this.zipError = false;
      this.zips = [];
      this.zip = "";
      this.isRequired = true;
      if (newCity.cityistat) {
        this.zipsState = true;
        axios({
          url: process.env.ROOT_API + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat,
          },
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            this.zips = resp.data.cap;
            this.zipsState = false;
          })
          .catch((resp) => {
            this.zips = [];
            this.zipsState = false;
          });
      }
    },
  },
  mounted: function () {
    this.setProfileData();
    this.populateProvincies();
  },
  created() {
    this.$validator.extend("notZeros", {
      getMessage: (field) =>
        " Il campo Numero di cellulare non ha un formato valido.",
      validate: (value) => {
        // value must be > zero
        if (
          value > 1000000 &&
          value.length > 1 &&
          value != 30000000 &&
          value != 300000000 &&
          value != 3000000000 &&
          value != 30000000000
        )
          return true;
        return false;
      },
    });
  },

  computed: {
    ...mapGetters([
      "getProfile",
      "isAuthenticated",
      "isProfileLoaded",
      "acceptCookies",
    ]),
    ...mapState({
      authLoading: (state) => state.auth.status === "loading",
      profile: (state) => state.user.profile,
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/account/index.vue